import { render, staticRenderFns } from "./loyaltyMomentTemplateCard.vue?vue&type=template&id=b43169c0&"
import script from "./loyaltyMomentTemplateCard.vue?vue&type=script&lang=js&"
export * from "./loyaltyMomentTemplateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports